import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { colors } from '../../utils';

export const useStyles = makeStyles((theme: Theme) => {
  return createStyles({
    cardHeader: {
      paddingBottom: 0,
      paddingTop: 5,
      paddingLeft: 5,
      background: colors.defaultGrey
    },
    cardFooter: {
      justifyContent: 'flex-end'
    },
    tableHeader: {
      background: colors.defaultGrey
    },
    tableHeaderFooter: {
      background: colors.defaultGrey
    },
    formControl: {
      margin: theme.spacing(1)
    },
    tableRowArrowCell: {
      paddingBottom: 0,
      paddingTop: 0
    },
    breakWord: {
      wordBreak: 'break-all'
    },
    filtersRow: {
      alignItems: 'center'
    }
  });
});
